import { writable } from "../util/customStores";
export const ram = writable();
export const cpu = writable();
export const wires = writable();
export const controls = writable();
export const messageFeed = writable();
export const logger = writable();
export const menu = writable();
export const stepText = writable();
export const settings = writable();
